/**
 * @module store/modules/apieditor
 * @description API Editor Vuex module for managing API configurations and mappings.
 *
 * This module provides functionality for:
 * - Creating, reading, updating, and deleting API configurations
 * - Managing API mappings for data transformation
 * - Previewing API calls with test data
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { ApiEditorState } from "./types";
import { RootState } from "@/store/types";

const apieditor: Module<ApiEditorState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default apieditor;
